import script from "./ScreenMirrorIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenMirrorIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenMirrorIndicator.vue?vue&type=style&index=0&id=04555d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04555d5c"]])

export default __exports__